import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Form, Row } from "react-bootstrap";
import { DocumentEntityTypesEnum, DocumentService, DocumentTypesEnum, UnitService, UnitTypesEnum, UnitVM } from "@propertelligent/client-api";
import AddTraspButton from "./commonCom/AddTraspButton";
import RadioButton from "../common/RadioButton";
import { getTenantList } from "../../redux/actions/unitAction";
import AddButtonWithArrow from "./commonCom/AddButtonWithArrow";
import Uploader from "../common/CustomUploader/Uploader";
import { FORM_CONTROLFIELD_TYPES } from "../../constants/constants";
import CounterBox from "./commonCom/IncDecBox";
import apiHelper from "../../utils/apiHelper";
import { useError } from "../../utils/context/ErrorContext";
import { validateUnitNumber, validateUnitNumberSize, } from "../../utils/validateHelper";
import CustomInputs from "../common/Inputs";
import NewSelectAuto from "../tenants/NewSelectAuto";
import { GetImages } from "../../utils/GetImages";
import { getProperty } from "../../redux/actions/propertyAction";

const UnitTanentForm = ({
  id,
  setShowModel,
  unitId,
  isEdit,
  setISEdit,
  canvasbody,
  unitTypesOptions = [] as any
}) => {
  const [fileName, setFileName] = useState("");
  const [mainImage, setMainImage] = useState(null);
  const [validated, setValidated] = useState(false);
  const [unitval, setUnitVal] = useState<UnitVM | any>({ propertyId: id });
  const [progress, setProgress] = useState(0);
  const dispatch: any = useDispatch();
  const { unitList } = useSelector((state: any) => state.unitList);
  const { errors, errorMessages, setErrors, setErrorMessages, clearErrors } = useError();

  const fetchUnitList = async () => {
    await UnitService.getApiUnitPropertylist(Number(id));
  };

  useMemo(() => { }, [unitList?.length, isEdit, unitId]);

  useEffect(() => {
    if (isEdit === true) {
      apiHelper(UnitService.getApiUnit1, { showNotification: false }, unitId)
        .then(async (unitDataRes: any) => {
          setUnitVal(unitDataRes?.data?.success);

          if (unitDataRes?.data?.success?.mainImageId !== 0) {
            apiHelper(
              DocumentService.getApiDocumentBase641,
              { showNotification: false },
              unitDataRes?.data.success?.mainImageId
            )
              .then((imageResponse: any) => {
                const imageData =
                  "data:image/*;base64," + imageResponse?.data?.success;
                setMainImage(imageData);
              })
              .catch((imageErr: any) => { });
          }
        })
        .catch((unitErr: any) => { });
    } else {
      setUnitVal({
        propertyId: id,
        unitNumber: "",
        size: "",
        unitTypeId: "",
        mainImageId: 0,
        numberOfBathrooms: 0,
        numberOfBedrooms: 0,
        isBathAttached: false,
      });
      setMainImage("");
      setFileName("");
    }
  }, [unitId, isEdit, unitval?.mainImageId, unitList?.length, id]);

  const handleOnChange = (e) => {
    setUnitVal({ ...unitval, [e.target.name]: e.target.value });
    clearErrors();
  };

  const checkEmptyFields = () => {
    let hasError = false;
    clearErrors();
    const newErrors = { ...errors };
    const newErrorMessages = { ...errorMessages };

    // Checking each field for emptiness and setting appropriate error messages
    if (!unitval.unitNumber) {
      newErrors.unitNumber = true;
      newErrorMessages.unitNumber = "Unit number is required";
      hasError = true
    } else {
      newErrors.unitNumber = false;
    }

    if (!unitval.size) {
      newErrors.unitNumberSize = true;
      newErrorMessages.unitNumberSize = "Unit Size is required";
      hasError = true
    } else if (unitval.size < 1 || unitval.size > 100000) {
      newErrors.unitNumberSize = true;
      newErrorMessages.unitNumberSize = "Size must be between 1 and 100,000";
      hasError = true;
    } else {
      newErrors.unitNumberSize = false;
    }

    if (!unitval.unitTypeId) {
      newErrors.unitTypeId = true;
      newErrorMessages.unitTypeId = "Unit type is required";
      hasError = true
    } else {
      newErrors.unitTypeId = false;
    }

    setErrors(newErrors);
    setErrorMessages(newErrorMessages);

    return hasError;
  };

  useEffect(() => {
    if (checkEmptyFields()) {
      clearErrors()
    }
  }, [])

  const resetForm = () => {
    // Reset form values
    setUnitVal({
      unitNumber: "",
      size: "",
      unitTypeId: "",
      numberOfBathrooms: "",
      numberOfBedrooms: "",
      isBathAttached: false,
    });
    setMainImage("");
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (checkEmptyFields()) {
      return;
    }

    else {
      if (!isEdit) {
        const response = await apiHelper(
          UnitService.postApiUnit,
          {
            successMessage: "Unit added successfully",
            failureMessage: "Unable to add unit",
            showNotification: true,
          },
          unitval
        );

        if (mainImage) {
          const imgData = {
            EntityTypeId: DocumentEntityTypesEnum.Unit,
            EntityId: Number(response?.data?.success?.id),
            DocumentTypeId: DocumentTypesEnum.Other,
            IsMain: true,
            Document: mainImage,
            FileName: fileName,
          };
          await apiHelper(
            DocumentService.postApiDocument,
            { showNotification: false },
            imgData
          );
        }

        if(response?.data?.success)
        {
          resetForm();
          clearErrors();
          setTimeout(() => {
            setShowModel(false);
          }, 500);

          dispatch(getTenantList(id));
          fetchUnitList();
          dispatch(getProperty(id))
          setValidated(false);
       }
      }
      else {
        const unitData = {
          id: unitval.id,
          propertyId: unitval.propertyId,
          unitNumber: unitval.unitNumber,
          unitTypeId: unitval.unitTypeId,
          size: unitval.size,
          numberOfBedrooms: unitval.numberOfBedrooms,
          numberOfBathrooms: unitval.numberOfBathrooms,
          isBathAttached: unitval.isBathAttached,
        };
        apiHelper(
          UnitService.putApiUnit,
          {
            successMessage: "Unit Updated Successfully",
            failureMessage: "Unable to update unit",
            showNotification: true,
          },
          unitData
        ).then((res: any) => {
          if (res?.data?.success) {  
            if (mainImage) {
              const imgData = {
                EntityTypeId: DocumentEntityTypesEnum.Unit,
                EntityId: Number(res?.data?.success?.id),
                DocumentTypeId: DocumentTypesEnum.Other,
                IsMain: true,
                Document: mainImage,
                FileName: fileName,
              };
               apiHelper(
                DocumentService.postApiDocument,
                { showNotification: false },
                imgData
              );
            }  
            fetchUnitList();
            setShowModel(false);
            setTimeout(() => {
              setISEdit(false);
            }, 500);
          }
        });
      }
    }
  };

  const handleDeleteUnit = () => {
    try {
      apiHelper(
        UnitService.deleteApiUnit,
        {
          successMessage: "Unit Deleted Successfully",
          failureMessage: "Unable to delete unit",
          showNotification: true,
        },
        unitId
      ).then((res) => {
        if (res?.data?.success) {
          setShowModel(false);
          setTimeout(() => {
            setISEdit(false);
          }, 1000);
          resetForm();
          dispatch(getTenantList(id));
        }
      });
    } catch (error) { }
  };

  return (
    <>
      {!isEdit ? (
        <Form
          noValidate
          validated={validated}
          onSubmit={(e) => handleSubmit(e)}
          style={{ marginBottom: "50px" }}
          className={`${canvasbody == true ? "unitTanentCanForm" : " unitTanentForm m-3"}`}
        >
          <div className={`${canvasbody == true ? "uploader-add-tenant p-3" : " uploader-add-tenant  "}`}>
            <Uploader
              name="Add Image"
              setMainImage={setMainImage}
              mainImage={mainImage}
              setFileName={setFileName}
              progress={progress}
              setProgress={setProgress}
              Size={{
                size: "Icon80",
                iconSize: "Icon11",
                pSize: 30,
                uploadimage: "iconstyle10",
              }}
              className="UploaderColumn"
              containerClassName="UploaderTextRow"
            />
          </div>

          <div className="inputParentBox p-3">
            <Form.Group>
              <Form.Label className="normal_text black">
                Select Unit Type *
              </Form.Label>

              <NewSelectAuto
                data={unitTypesOptions}
                type={"Unit Type"}
                disabled={undefined}
                setDisabled={undefined}
                selected={unitval?.unitTypeId || null}
                setSelected={(value) =>
                  setUnitVal({
                    ...unitval,
                    unitTypeId: Number(value),
                  })
                }
                title={undefined}
                error={errors.unitTypeId}
                setError={() => setErrors({ ...errors, unitTypeId: false })}
                errorMessage={errorMessages.unitTypeId}
                width="100%"
              />
            </Form.Group>
          </div>
          <div className={`${canvasbody == true ? "parentDiv flex-column" : " parentDiv"}`}>
            <div className={canvasbody == true ? "inputParentBox px-3" : "inputParentBox p-3"}>
              <Form.Group>
                <CustomInputs
                  labelText="Unit Number"
                  name="unitNumber"
                  isFormControl
                  type={FORM_CONTROLFIELD_TYPES.TEXT}
                  value={unitval?.unitNumber || ""}
                  required
                  onChange={(e) => {
                    handleOnChange(e);
                    setErrors((prev) => ({ ...prev, unitNumber: false }));
                  }}
                  onBlur={() => {
                    validateUnitNumber(
                      unitval.unitNumber,
                      setErrors,
                      setErrorMessages
                    );
                  }}
                  placeholder="Enter Unit Number"
                  myClassName="containerTextField"
                  isError={errors.unitNumber}
                  errorMessages={errorMessages.unitNumber}
                />
              </Form.Group>
            </div>
            <div className={canvasbody == true ? "inputParentBox px-3" : "inputParentBox p-3"}>
              <Form.Group>
                <CustomInputs
                  labelText="Area Sqft"
                  name={"size"}
                  isFormControl={true}
                  value={unitval?.size}
                  required
                  type={FORM_CONTROLFIELD_TYPES.NUMBER}
                  onChange={(e) => {
                    handleOnChange(e)
                    setErrors((prev) => ({ ...prev, unitNumberSize: false }));
                  }}
                  placeholder="Enter Unit Size in Sqft"
                  myClassName="containerTextField"
                  onBlur={() => {
                    validateUnitNumberSize(
                      unitval?.size,
                      setErrors,
                      setErrorMessages
                    );
                  }}
                  isError={errors.unitNumberSize}
                  errorMessages={errorMessages.unitNumberSize}
                />
              </Form.Group>
            </div>
          </div>

          {unitval?.unitTypeId === 1 ? (
            <>
              <div className="CondominiumSection p-3">
                <div className="condominium">
                  <div className="bedroom">
                    <p className="normal_text grey_subtext1">Bedroom</p>
                    <CounterBox
                      unitval={unitval}
                      setUnitVal={setUnitVal}
                      type="bedroom"
                      initialValue={unitval?.numberOfBedrooms}
                    />
                  </div>
                  <div className="bathroom">
                    <p className="normal_text grey_subtext1">Bathroom</p>
                    <CounterBox
                      unitval={unitval}
                      setUnitVal={setUnitVal}
                      type="bathroom"
                      initialValue={unitval?.numberOfBathrooms}
                    />
                  </div>
                </div>
              </div>
            </>
          ) : unitval?.unitTypeId === 3 ? (
            <div className="parentDiv px-3">
              <div className="inputParentBox">
                <p className="normal_text grey_subtext1">Bathrooms</p>
                <div className="paymentRadioButton">
                  <RadioButton
                    label="Attached"
                    name="isBathAttached"
                    value={unitval?.isBathAttached}
                    checked={unitval?.isBathAttached === true}
                    onChange={(e) => {
                      setUnitVal({
                        ...unitval,
                        isBathAttached: Boolean(true),
                      });
                    }}
                  />
                  <RadioButton
                    label="Common"
                    name="isBathAttached"
                    value={unitval?.isBathAttached}
                    checked={unitval?.isBathAttached === false}
                    onChange={(e) => {
                      setUnitVal({
                        ...unitval,
                        isBathAttached: Boolean(false),
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          ) : unitval?.unitTypeId === 2 ? (
            ""
          ) : (
            ""
          )}

          <div className="editFormFooter start-0">
            <AddTraspButton
              type="button"
              bname="Cancel"
              onClick={() => setShowModel(false)}
              border={false}
              width="fit-content"
            />

            <AddButtonWithArrow
              type="submit"
              buttonname="Add Unit"
            />
          </div>
        </Form>
      ) : (
        <Form
          noValidate
          validated={validated}
          onSubmit={(e) => handleSubmit(e)}
          className="unitTanentForm m-3"
        >
          <div className="uploader-add-tenant">
            <Uploader
              name="Add Image"
              setMainImage={setMainImage}
              documentId={unitval?.mainImageId}
              mainImage={mainImage}
              setFileName={setFileName}
              progress={progress}
              setProgress={setProgress}
              Size={{
                size: "Icon80",
                iconSize: "Icon11",
                pSize: 30,
                uploadimage: "iconstyle10",
              }}
              className="UploaderColumn"
              containerClassName="UploaderTextRow"
            />
          </div>

          <Row>
            <Col className="inputParentBox">
              <Form.Group>
                <Form.Label className="normal_text black">
                  Select Unit Type *
                </Form.Label>
                <NewSelectAuto
                  data={unitTypesOptions}
                  type={"Unit Type"}
                  disabled={undefined}
                  setDisabled={undefined}
                  selected={unitval?.unitTypeId || ""}
                  setSelected={(value) =>
                    setUnitVal({
                      ...unitval,
                      unitTypeId: Number(value),
                    })
                  }
                  title={undefined}
                  error={errors.unitTypeId}
                  setError={() => setErrors({ ...errors, unitTypeId: false })}
                  errorMessage={errorMessages.unitTypeId}
                  width="100%"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="parentDiv d-flex flex-column gap-2">
            <Col className="inputParentBox">
              <Form.Group>
                <CustomInputs
                  labelText="Unit Number"
                  name="unitNumber"
                  isFormControl
                  type={FORM_CONTROLFIELD_TYPES.TEXT}
                  value={unitval?.unitNumber || ""}
                  required
                  onChange={(e) => {
                    handleOnChange(e);
                    setErrors((prev) => ({ ...prev, unitNumber: false }));
                  }}
                  onBlur={() => {
                    validateUnitNumber(
                      unitval.unitNumber,
                      setErrors,
                      setErrorMessages
                    );
                  }}
                  placeholder="Enter Unit Number"
                  myClassName="containerTextField"
                  isError={errors.unitNumber}
                  errorMessages={errorMessages.unitNumber}
                />
              </Form.Group>
            </Col>
            <Col className="inputParentBox">
              <Form.Group>
                <CustomInputs
                  labelText="Area sq. ft"
                  name={"size"}
                  isFormControl={true}
                  value={unitval?.size}
                  required
                  type={FORM_CONTROLFIELD_TYPES.NUMBER}
                  onChange={(e) => {
                    handleOnChange(e)
                    setErrors((prev) => ({ ...prev, unitNumberSize: false }));
                  }}
                  placeholder="Area in Square Feet"
                  myClassName="containerTextField"
                  onBlur={() =>
                    validateUnitNumberSize(
                      unitval?.size,
                      setErrors,
                      setErrorMessages
                    )
                  }
                  isError={errors.unitNumberSize}
                  errorMessages={errorMessages.unitNumberSize}
                />
              </Form.Group>
            </Col>
          </Row>

          {unitval?.unitTypeId === 1 ? (
            <>
              <div className="CondominiumSection px-2">
                <div className="condominium">
                  <div className="bathroom">
                    <p className="normal_text grey_subtext1">Bathroom</p>
                    <CounterBox
                      unitval={unitval}
                      setUnitVal={setUnitVal}
                      type="bathroom"
                      initialValue={unitval?.numberOfBathrooms}
                    />
                  </div>
                  <div className="bedroom">
                    <p className="normal_text grey_subtext1">Bedroom</p>
                    <CounterBox
                      unitval={unitval}
                      setUnitVal={setUnitVal}
                      type="bedroom"
                      initialValue={unitval?.numberOfBedrooms}
                    />
                  </div>
                </div>
              </div>
            </>
          ) : unitval?.unitTypeId === 3 ? (
            <div className="parentDiv">
              <div className="inputParentBox p-3">
                <p className="normal_text grey_subtext1">Bathrooms</p>
                <div className="paymentRadioButton">
                  <RadioButton
                    label="Attached"
                    name="isBathAttached"
                    value={unitval?.isBathAttached}
                    checked={unitval?.isBathAttached === true}
                    onChange={(e) => {
                      setUnitVal({
                        ...unitval,
                        isBathAttached: Boolean(true),
                      });
                    }}
                  />
                  <RadioButton
                    label="Common"
                    name="isBathAttached"
                    value={unitval?.isBathAttached}
                    checked={unitval?.isBathAttached === false}
                    onChange={(e) => {
                      setUnitVal({
                        ...unitval,
                        isBathAttached: Boolean(false),
                      });
                    }}
                  />
                </div>
              </div>
            </div>
          ) : unitval?.unitTypeId === 2 ? (
            ""
          ) : (
            ""
          )}

          <div className="editFormFooter start-0">
            <div
              className="deletereplace"
              style={{ position: "absolute", left: "12px" }}
              onClick={handleDeleteUnit}
            >
              <img src={GetImages.deleteIconRed} className="iconstyle" />
              <p className="delete">Delete</p>
            </div>
            <AddTraspButton
              type="button"
              bname="Cancel"
              onClick={() => setISEdit(false)}
              border={false}
              width="fit-content"
            />

            <AddButtonWithArrow
              type="submit"
              buttonname="Update details"
            />
          </div>
        </Form>
      )}
    </>
  );
};

export default UnitTanentForm;
